module.exports = __webpack_public_path__ + "img/logo-icoev.a5ba710c.svg";